export enum AuthConsumer {
  Greenroom = 'Greenroom',
  /** @deprecated */
  Platform = 'Platform',
  BrandlivePlatform = 'Brandlive Platform',
  BrandTV = 'BrandTV',
  VirtualPro = 'VirtualPro',
  WebinarPlus = 'WebinarPlus',
}
